export const WELFARE_CARD = 'welfare';
export const BONUS_CARD = 'bonus';
export const TAB_INFO = [
  {
    label: '加成卡',
    id: BONUS_CARD,
  },
  {
    label: '福利码',
    id: WELFARE_CARD,
  },
];

export const ALL_STATUS = 'all';
export const UNUSED_STATUS = 'touse';
export const USING_STATUS = 'inuse';
export const EXPIRED_STATUS = 'expired';
export const FINISHED_STATUS = 'reward_end';
export const UNKNOWN_STATUS = 'unknown';
export const WELFARE_STATUS_INFO = [
  {
    label: '全部',
    id: ALL_STATUS,
  },
  {
    label: '待使用',
    id: UNUSED_STATUS,
  },
  {
    label: '使用中',
    id: USING_STATUS,
  },
  {
    label: '已过期',
    id: EXPIRED_STATUS,
  },
  {
    label: '已结束',
    id: FINISHED_STATUS,
  },
];

export const BOUNS_UNUSED_STATUS = 0;
export const BOUNS_USING_STATUS = 1;
export const BOUNS_EXPIRED_STATUS = 2;
export const BOUNS_USED_STATUS = 3;

export const BOUNS_CARD_CLASSNAME = {
  [BOUNS_UNUSED_STATUS]: 'unused',
  [BOUNS_USING_STATUS]: 'using',
  [BOUNS_USED_STATUS]: 'used',
  [BOUNS_EXPIRED_STATUS]: 'expired',
};

export const BOUNS_DEVICE_LIMIT = {
  1: '全部设备可用',
  2: '部分设备可用',
};

export const BOUNS_STATUS_INFO = [
  {
    label: '未使用',
    id: `${BOUNS_UNUSED_STATUS}`,
  },
  {
    label: '使用中/已使用',
    id: `${BOUNS_USING_STATUS},${BOUNS_USED_STATUS}`,
  },
  {
    label: '已失效',
    id: `${BOUNS_EXPIRED_STATUS}`,
  },
];

export const BTN_TEXT_MAP = {
  [UNUSED_STATUS]: '去使用',
  [USING_STATUS]: '使用中…',
  [EXPIRED_STATUS]: '已过期',
  [FINISHED_STATUS]: '已结束',
  [UNKNOWN_STATUS]: '未知',
};

export const DETAIL_BTN_TEXT_MAP = {
  [UNUSED_STATUS]: '使用教程',
  [USING_STATUS]: '使用中…',
  [EXPIRED_STATUS]: '已过期',
  [FINISHED_STATUS]: '已结束',
  [UNKNOWN_STATUS]: '未知',
};

export const SHOW_RED_DOT = 1;
export const HIDE_RED_DOT = 0;

export const PAGE_SIZE = 20;

export const REWARD_START_TIME = 'reward_start_time';
export const REWARD_END_TIME = 'reward_end_time';
export const DEVICE_TYPES = 'device_types';

export const CODE_INFO_ARRAY = [
  {
    field: 'busi_name',
    title: '名称',
  },
  {
    field: 'expire_time',
    title: '有效期至',
  },
  {
    field: 'buy_time',
    title: '获得时间',
  },
  {
    field: 'buy_channel',
    title: '获得方式',
  },
  {
    field: 'sn',
    title: '关联设备',
  },
  {
    field: 'bind_time',
    title: '使用时间',
  },
  {
    field: REWARD_START_TIME,
    title: '奖励起始时间',
  },
  {
    field: REWARD_END_TIME,
    title: '奖励结束时间',
  },
  {
    field: DEVICE_TYPES,
    title: '可用设备',
  },
];

export const MODULE = 'my_rights';
